// @ts-ignore
export default async (messageBus, langCode) => {
  if (!messageBus) {
    messageBus = await import('@wh/message-bus');
  }

  // @ts-ignore
  const messagingApp = (await import('@wh/overlay-messaging')).default;
  messagingApp(messageBus, langCode);

  const url = window.location.host;
  const domainNameWithoutCB = 'sports.williamhill';
  const domainExtensionsWithoutCB = ['.it', '.es'];
  const isDomainNameWithoutCB = url.includes(domainNameWithoutCB);
  const isDomainExtensionWithoutCB = domainExtensionsWithoutCB.some((i) => url.includes(i));
  const isDomainWithoutCB = isDomainNameWithoutCB && isDomainExtensionWithoutCB;

  // don't load cookie banner for Sportsbook IT & ES
  if (!isDomainWithoutCB) {
    // @ts-ignore
    const cookieDisclaimerUi = (await import('@wh/overlay-cookieDisclaimer')).default;
    cookieDisclaimerUi(messageBus, langCode);
  }
};
